let API = {
    baseURL:'https://www.fioboc.com/',
    timeout: 1000,
    responseEncoding: 'utf8',
}

// var loadJS = function(url) {
//   const script = document.createElement('script');
//   script.type = 'text/javascript';
//   script.src = url;
//   document.body.appendChild(script);
// }

// var loadCSS = function(url) {
//   const link = document.createElement('link');
//   link.rel = 'stylesheet';
//   link.type = 'text/css';
//   link.href = url;
//   document.head.appendChild(link);
// }
var fitName = [
  'Classic Fit',
  'Slim Fit',
  'Relaxed Fit',
  'Classic Fit Bottoms',
  'Slim Fit Bottoms',
  "Relaxed Fit Bottoms"
]
const request = axios.create(API);
const microGovernanceMap = new Map();
const CancelToken = axios.CancelToken;
request.interceptors.request.use(config => {
  const { method, url, data, params, cache } = config;
  if (cache) {
    const source = CancelToken.source()
    config.cancelToken = source.token
    const key = `${filterTimeUrl}_${JSON.stringify(method === 'get' ? params : data)}`
    if (microGovernanceMap.has(key)) {
      source.cancel(microGovernanceMap.get(key))
    }
  }
  return config;
});
request.interceptors.response.use(function (response) {
  const { method, url, params, data, cache } = response.config;
  if (cache) {
    const key = `${filterTimeUrl}_${method === 'get' ? JSON.stringify(params) : data}`
    if (!microGovernanceMap.has(key)) {
      microGovernanceMap.set(key, response.data)
    }
  }
  return response.data;
})

window.getProductRecommendationList = async function(url){
  return axios({
    method:'get',
    url,
    responseType: 'stream',
    headers:{
      'Content-Type': 'text/html;charset=utf-8'
    },
    transformResponse: [
       function(response){
        const responseHTML = new DOMParser().parseFromString(response, 'text/html');
        return responseHTML;
      }
    ],
    cache: true
  })
}
window.getCollectData = async function(url) {
  return axios({
    method:'get',
    url,
    responseType: 'stream',
    headers:{
      'Content-Type': 'text/html;charset=utf-8'
    },
    transformResponse: [
       function(response){
        const responseHTML = new DOMParser().parseFromString(response, 'text/html');
        return responseHTML;
      }
    ],
    cache: true
  })
}
window.recommendCartList = async function(url){
  return axios({
    method:'get',
    url,
    responseType: 'stream',
    headers:{
      'Content-Type': 'text/html;charset=utf-8'
    },
    transformResponse: [
       function(response){
        const responseHTML = new DOMParser().parseFromString(response, 'text/html');
        return responseHTML;
      }
    ],
    cache: true
  })
}

window.addProduct = async function(data){
  return axios({
    method:'post',
    url:'/cart/add',
    data,
    headers:{
       "Content-Type": "application/json",
        "Accept": "application/javascript"
    },
    // transformResponse: [
    //    function(response){
    //      const responseJSON = JSON.parse(response);
    //       return responseJSON;
    //   }
    // ],
    cache: true,
  })
}
window.delProduct = function(data){
  return axios({
    method:'post',
    url:'/cart/change',
    data,
    headers:{
      "Content-Type": "application/json",
      "Accept": "application/javascript"
    },
    transformResponse: [
       function(response){
         const responseJSON = JSON.parse(response);
          return responseJSON;
      }
    ],
    cache: true,
  })
}
var getQVHTML = function(url){
  return axios.get(url,{
    responseType: 'stream',
    headers:{
      'Content-Type': 'text/html;charset=utf-8'
    },
    transformResponse: [
       function(response){
        const responseHTML = new DOMParser().parseFromString(response, 'text/html');
        return responseHTML;
      }
    ],
    cache: true
  })
}

var postAddCart = function(url,data){
  return axios({
    method:'post',
    url,
    headers:{
      'X-Requested-With':'XMLHttpRequest',
      'Accept': 'application/javascript',
    },
    data
  })
}

var postProductData = function(data){
  return axios({
    method:'post',
    url:"https://thimatic-apps.com/product_review/get_product_review_filter.php",
    headers:{
       "Content-Type": "multipart/form-data;text/html; charset=UTF-8",
    },
    transformResponse: [
       function(response){
        const responseHTML = new DOMParser().parseFromString(response, 'text/html');
        return responseHTML;
      }
    ],
    data:{
        "shop": "fioboc.myshopify.com",
        "product_handle":data.product_handle,
        "page_url": data.page_url,
        "product_id": data.product_id,
        "filter":"with-pictures",
        "rating_val": "",
        "load_more": "",
        "limit":data.limit
    },
    cache: true,
  })
}
window.postProductData = function(url){
   return axios.get(url,{
    // responseType: 'stream',
    headers:{
      'Content-Type': 'text/html;charset=utf-8'
    },
    cache: true
  })
}
window.postCartRecommandationsData = function(){
   return axios.get('/pages/cart-recommendations',{
    responseType: 'stream',
    headers:{
      'Content-Type': 'text/html;charset=utf-8'
    },
    transformResponse: [
       function(response){
        const responseHTML = new DOMParser().parseFromString(response, 'text/html');
        return responseHTML;
      }
    ],
    cache: true
  })
}
var postBodySizeData = function(url){
   return axios.get(url,{
    responseType: 'stream',
    headers:{
      'Content-Type': 'text/html;charset=utf-8'
    },
    transformResponse: [
       function(response){
        const responseHTML = new DOMParser().parseFromString(response, 'text/html');
        return responseHTML;
      }
    ],
    cache: true
  })
}
var getProductBroupHTML = function(url){
    return axios.get(url,{
      responseType: 'stream',
      headers:{
        'Content-Type': 'text/html;charset=utf-8'
      },
      transformResponse: [
         function(response){
          const responseHTML = new DOMParser().parseFromString(response, 'text/html');
          return responseHTML;
        }
      ],
      cache: true
    })
}
var getCartList = function(){
  let url = '/cart.json';
  return axios.get(url,{
      responseType: 'stream',
      headers:{
        'Content-Type': 'text/javascript; charset=utf-8'
      },
      transformResponse: [
         function(response){
           const responseJSON = JSON.parse(response);
            return responseJSON;
        }
      ],
      cache: true
  })
}